<div class="container-fluid">
    <app-frame [frameSrc]="url" frameType="custom" id="CUSTS"></app-frame>
</div>
